<div class="modal-header">
  <h4 class="modal-title fw-normal">{{ title() }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body d-flex align-items-center">
  <p class="alert d-flex align-items-center gap-2 mb-0 w-100" [class]="alertClasses()">
    @if (alertIcon()) {
      <i class="bi lh-1" [class]="alertIcon()" aria-hidden="true"></i>
    }
    <span>{{ message() }}</span>
  </p>
</div>
<div class="modal-footer">
  @if (showCancelButton()) {
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">{{ cancelButtonText() }}</button>
  }
  <button type="button" class="btn" [class]="confirmButtonClass()" (click)="confirm()">{{ confirmButtonText() }}</button>
</div>
